// ThemeSwitcher.jsx
import { useTheme } from "../context/ThemeContext";
import "./ThemeSwitcher.css";

export default function ThemeSwitcher() {
  const { theme, switchTheme, themes } = useTheme();

  const themeConfig = {
    light: { icon: "☀️", label: "Light" },
    dark: { icon: "🌙", label: "Dark" },
    ocean: { icon: "🌊", label: "Ocean" },
    forest: { icon: "🌲", label: "Forest" },
    sunset: { icon: "🌅", label: "Sunset" },
    purple: { icon: "💜", label: "Purple" },
    cyberpunk: { icon: "⚡", label: "Cyber" },
  sanjay: { icon: "🎓", label: "Sanjay" },
    };

  return (
    <div className="theme-switcher">
      <div className="theme-label">Theme:</div>
      <div className="theme-buttons">
        {themes.map((t) => (
          <button
            key={t}
            className={`theme-btn ${theme === t ? "active" : ""}`}
            onClick={() => switchTheme(t)}
            title={themeConfig[t].label}
            aria-label={`Switch to ${themeConfig[t].label} theme`}
          >
            {themeConfig[t].icon}
          </button>
        ))}
      </div>
    </div>
  );
}
